import { render, staticRenderFns } from "./RubricaIndex.vue?vue&type=template&id=497764fd&"
import script from "./RubricaIndex.vue?vue&type=script&lang=js&"
export * from "./RubricaIndex.vue?vue&type=script&lang=js&"
import style0 from "./RubricaIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports